module.exports = __webpack_public_path__ + "4fd02d5758fcf78b86917c276fd1271a.MP3";